import { render, staticRenderFns } from "./AddZigzagPage.vue?vue&type=template&id=2833b7f1&"
import script from "./AddZigzagPage.vue?vue&type=script&lang=js&"
export * from "./AddZigzagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports